// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file api/v1/auth.proto (package api.v1, syntax proto3)
/* eslint-disable */

import type {
  GenFile,
  GenMessage,
  GenService,
} from "@bufbuild/protobuf/codegenv1";
import {
  fileDesc,
  messageDesc,
  serviceDesc,
} from "@bufbuild/protobuf/codegenv1";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import {
  file_google_protobuf_empty,
  file_google_protobuf_field_mask,
  file_google_protobuf_timestamp,
} from "@bufbuild/protobuf/wkt";
import type { UserProfile } from "./user_pb";
import { file_api_v1_user } from "./user_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/v1/auth.proto.
 */
export const file_api_v1_auth: GenFile =
  /*@__PURE__*/
  fileDesc(
    "ChFhcGkvdjEvYXV0aC5wcm90bxIGYXBpLnYxIr0BCg9SZWdpc3RlclJlcXVlc3QSEQoJZnVsbF9uYW1lGAEgASgJEgsKA2NwZhgCIAEoCRIuCgpiaXJ0aF9kYXRlGAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBINCgVwaG9uZRgEIAEoCRINCgVlbWFpbBgFIAEoCRIQCghwYXNzd29yZBgGIAEoCRIZCgxzcG9uc29yX2NvZGUYByABKAlIAIgBAUIPCg1fc3BvbnNvcl9jb2RlIi8KDExvZ2luUmVxdWVzdBINCgVlbWFpbBgBIAEoCRIQCghwYXNzd29yZBgCIAEoCSJ/CgxBdXRoUmVzcG9uc2USFAoMYWNjZXNzX3Rva2VuGAEgASgJEh8KF2FjY2Vzc190b2tlbl9leHBpcmVzX2F0GAIgASgDEhUKDXJlZnJlc2hfdG9rZW4YAyABKAkSIQoEdXNlchgEIAEoCzITLmFwaS52MS5Vc2VyUHJvZmlsZSIsChNSZWZyZXNoVG9rZW5SZXF1ZXN0EhUKDXJlZnJlc2hfdG9rZW4YASABKAky+gEKC0F1dGhTZXJ2aWNlEjkKCFJlZ2lzdGVyEhcuYXBpLnYxLlJlZ2lzdGVyUmVxdWVzdBoULmFwaS52MS5BdXRoUmVzcG9uc2USMwoFTG9naW4SFC5hcGkudjEuTG9naW5SZXF1ZXN0GhQuYXBpLnYxLkF1dGhSZXNwb25zZRJBCgxSZWZyZXNoVG9rZW4SGy5hcGkudjEuUmVmcmVzaFRva2VuUmVxdWVzdBoULmFwaS52MS5BdXRoUmVzcG9uc2USOAoGTG9nb3V0EhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5GhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5QhtaGWNhc2hicm9rZXIvZ2VuL2FwaS92MTthcGliBnByb3RvMw",
    [
      file_google_protobuf_empty,
      file_google_protobuf_timestamp,
      file_google_protobuf_field_mask,
      file_api_v1_user,
    ],
  );

/**
 * @generated from message api.v1.RegisterRequest
 */
export type RegisterRequest = Message<"api.v1.RegisterRequest"> & {
  /**
   * @generated from field: string full_name = 1;
   */
  fullName: string;

  /**
   * @generated from field: string cpf = 2;
   */
  cpf: string;

  /**
   * @generated from field: google.protobuf.Timestamp birth_date = 3;
   */
  birthDate?: Timestamp;

  /**
   * @generated from field: string phone = 4;
   */
  phone: string;

  /**
   * @generated from field: string email = 5;
   */
  email: string;

  /**
   * @generated from field: string password = 6;
   */
  password: string;

  /**
   * @generated from field: optional string sponsor_code = 7;
   */
  sponsorCode?: string;
};

/**
 * Describes the message api.v1.RegisterRequest.
 * Use `create(RegisterRequestSchema)` to create a new message.
 */
export const RegisterRequestSchema: GenMessage<RegisterRequest> =
  /*@__PURE__*/
  messageDesc(file_api_v1_auth, 0);

/**
 * @generated from message api.v1.LoginRequest
 */
export type LoginRequest = Message<"api.v1.LoginRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;
};

/**
 * Describes the message api.v1.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema: GenMessage<LoginRequest> =
  /*@__PURE__*/
  messageDesc(file_api_v1_auth, 1);

/**
 * @generated from message api.v1.AuthResponse
 */
export type AuthResponse = Message<"api.v1.AuthResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: int64 access_token_expires_at = 2;
   */
  accessTokenExpiresAt: bigint;

  /**
   * @generated from field: string refresh_token = 3;
   */
  refreshToken: string;

  /**
   * @generated from field: api.v1.UserProfile user = 4;
   */
  user?: UserProfile;
};

/**
 * Describes the message api.v1.AuthResponse.
 * Use `create(AuthResponseSchema)` to create a new message.
 */
export const AuthResponseSchema: GenMessage<AuthResponse> =
  /*@__PURE__*/
  messageDesc(file_api_v1_auth, 2);

/**
 * @generated from message api.v1.RefreshTokenRequest
 */
export type RefreshTokenRequest = Message<"api.v1.RefreshTokenRequest"> & {
  /**
   * @generated from field: string refresh_token = 1;
   */
  refreshToken: string;
};

/**
 * Describes the message api.v1.RefreshTokenRequest.
 * Use `create(RefreshTokenRequestSchema)` to create a new message.
 */
export const RefreshTokenRequestSchema: GenMessage<RefreshTokenRequest> =
  /*@__PURE__*/
  messageDesc(file_api_v1_auth, 3);

/**
 * @generated from service api.v1.AuthService
 */
export const AuthService: GenService<{
  /**
   * @generated from rpc api.v1.AuthService.Register
   */
  register: {
    methodKind: "unary";
    input: typeof RegisterRequestSchema;
    output: typeof AuthResponseSchema;
  };
  /**
   * @generated from rpc api.v1.AuthService.Login
   */
  login: {
    methodKind: "unary";
    input: typeof LoginRequestSchema;
    output: typeof AuthResponseSchema;
  };
  /**
   * @generated from rpc api.v1.AuthService.RefreshToken
   */
  refreshToken: {
    methodKind: "unary";
    input: typeof RefreshTokenRequestSchema;
    output: typeof AuthResponseSchema;
  };
  /**
   * @generated from rpc api.v1.AuthService.Logout
   */
  logout: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof EmptySchema;
  };
}> = /*@__PURE__*/ serviceDesc(file_api_v1_auth, 0);
